exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-graficbar-component{padding:10px}.card-graficbar-component .card-category{font-size:12px;line-height:12px;font-family:\"SF Pro Rounded\",sans-serif;font-weight:bold}.card-graficbar-component .card-body{padding:8px 0 0 0}.card-graficbar-component .card-body h2{font-size:14px;line-height:14px;font-family:\"SF Pro Rounded\",sans-serif}.card-graficbar-component .card-body img{min-height:40px}", ""]);

// exports
